import { render, staticRenderFns } from "./MediaDetailPanel.vue?vue&type=template&id=07453743"
import script from "./MediaDetailPanel.vue?vue&type=script&lang=js"
export * from "./MediaDetailPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports